import { AfterContentInit, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FormColumnComponent } from '@hub/components/v1/form-components/form-column/form-column.component';

@Component({
  selector: 'fm-group',
  templateUrl: 'form-group.component.html'
})
export class FormGroupComponent
  implements  OnInit, OnDestroy, AfterContentInit {
  constructor(
    private formCol: FormColumnComponent,
  ) {
  }

  labelClass: string = "";
  divClass: string = "";
  @Input() name: string = "";

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    if (this.formCol) {
      this.labelClass = this.formCol.labelClass;
      this.divClass = this.formCol.divClass;
    }
  }

  ngOnDestroy() {
  }
}
